<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors, invalid, validated }"
    :mode="validateMode"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :loading="loading"
      :error="errors[0]"
      :normal-label="normalLabel"
      classes="pull_left"
    >
      <div
        :id="formControlId"
        :class="checkboxGroupClass"
        :style="{
          height:
            activeShowMoreItems && !showMoreItems ? showMoreItemsHeight : null,
        }"
      >
        <ul>
          <li
            v-for="(option, optionIndex) in options"
            :key="`${formControlId}_${optionIndex}`"
            :style="invalid && validated ? 'border-color: #d75363' : ''"
          >
            <input
              type="checkbox"
              :id="`${formControlId}_${optionIndex}`"
              :value="option"
              v-model="proxy"
              @change="onInput"
              class="form_input_radio"
              v-bind="formControlOptions"
            />
            <label
              :title="returnObject ? option[itemText] : option"
              :for="`${formControlId}_${optionIndex}`"
            >
              <span class="label_inner_text">
                {{ returnObject ? option[itemText] : option }}
              </span>
            </label>
          </li>
        </ul>
      </div>
      <a
        v-if="activeShowMoreItems"
        href="#"
        class="vvs-checkbox-show-more-items-button"
        v-text="!showMoreItems ? showMoreItemsText : hideFewerItemsText"
        @click.prevent="toggleShowMoreItems"
      ></a>
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
export default {
  name: 'VvsCheckbox',
  mixins: [formControlMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    showMoreItemsLimit: {
      type: [Number, String],
      default: 100,
    },
    showMoreItemsScrollOffset: {
      type: [Number, String],
      default: -40,
    },
    showMoreItemsHeight: {
      type: String,
      default: '200px',
    },
    showMoreItemsText: {
      type: String,
      default: 'Daha fazla öğe göster',
    },
    hideFewerItemsText: {
      type: String,
      default: 'Daha az öğe göster',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      proxy: [],
      showMoreItems: false,
    };
  },
  computed: {
    activeShowMoreItems() {
      return this.options.length > Number(this.showMoreItemsLimit);
    },
    checkboxGroupClass() {
      return {
        'radio_group_4 mobile_width_half': this.small,
        'radio_group_3 mobile_full_width': !this.small,
        'vvs-checkbox-show-more-items':
          this.activeShowMoreItems && !this.showMoreItems,
      };
    },
  },
  methods: {
    toggleShowMoreItems() {
      this.showMoreItems = !this.showMoreItems;
      this.$nextTick(() => {
        this.$scrollTo(`#${this.formControlId}`, {
          offset: Number(this.showMoreItemsScrollOffset),
        });
      });
    },
  },
};
</script>

<style lang="scss">
.vvs-checkbox-show-more-items {
  overflow-y: hidden;
}
.vvs-checkbox-show-more-items-button {
  display: inline-block;
  font-family: 'BrandonTextRegular';
  color: #40484e;
  font-size: 13px;
  margin-top: 10px;
}
</style>
